// extracted by mini-css-extract-plugin
export default {"Heading":"Heading_Heading__l5IfP","swing-in":"Heading_swing-in__Sgjf-"};